module.exports = __webpack_public_path__ + "static/media/warn1.591abfe9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/warn1.jpg
// module id = 345
// module chunks = 2